// Guardia de sesión global.
// Cuando el token JWT vence, el usuario no ve errores raros: al primer click
// (o ante cualquier 401 de nuestra API) se cierra la sesión y se lo lleva a
// /login?expirada=1, donde Login muestra el aviso "tu sesión expiró".

const API_URL = process.env.REACT_APP_API_URL || '';

export function getTokenExp() {
  const token = localStorage.getItem('token');
  if (!token) return null;
  try {
    const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(atob(base64));
    return typeof payload.exp === 'number' ? payload.exp : null;
  } catch (e) {
    return null;
  }
}

export function isTokenExpired() {
  const exp = getTokenExp();
  return exp !== null && exp * 1000 <= Date.now();
}

export function forceLogout() {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  if (window.location.pathname !== '/login') {
    window.location.replace('/login?expirada=1');
  }
}

let instalado = false;

export function installSessionGuard() {
  if (instalado) return;
  instalado = true;

  // 1) Cualquier interacción con token vencido → login.
  //    Fase de captura: corre antes que los handlers de React.
  document.addEventListener(
    'click',
    () => {
      if (isTokenExpired()) forceLogout();
    },
    true
  );

  // 2) Cualquier 401 de nuestra API estando "logueado" → login.
  //    Cubre el caso de que el token venza en el medio de una request.
  const originalFetch = window.fetch.bind(window);
  window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    if (response.status === 401) {
      const url =
        typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
      const teniaToken = !!localStorage.getItem('token');
      if (teniaToken && API_URL && url.startsWith(API_URL)) {
        forceLogout();
      }
    }
    return response;
  };
}
